import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { disableSuperadminPush, enableSuperadminPush, getPushCapability, hasActiveSubscription, sendTestPush } from "../../../services/superadmin/superadminPush";
import { showError, showSuccess, showWarning } from "../../../components/alertas";
import logger from "../../../utils/logger";

/**
 * Campana de la barra superior: activa/desactiva las alertas push en ESTE
 * dispositivo. Debe dispararse desde un tap (iOS exige gesto para pedir permiso).
 */
export default function PushToggle() {
  const [state, setState] = useState(() => getPushCapability()); // unsupported | needs-install | default | denied | granted
  const [active, setActive] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { hasActiveSubscription().then(setActive); }, [state]);

  const onClick = async () => {
    if (busy) return;
    if (state === "unsupported") return showWarning("Sin soporte", "Este navegador no soporta notificaciones push.");
    if (state === "needs-install") return showWarning("Instala la app primero", "En iPhone, agrega /admin a la pantalla de inicio (Compartir → Agregar a inicio) y activa las notificaciones desde ahí.");
    if (state === "denied") return showWarning("Permiso bloqueado", "Las notificaciones están bloqueadas para este sitio; actívalas en los ajustes del navegador.");
    setBusy(true);
    try {
      if (active) {
        await disableSuperadminPush();
        setActive(false);
        showSuccess("Notificaciones desactivadas", "Este dispositivo ya no recibirá alertas.");
      } else {
        const perm = await enableSuperadminPush();
        setState(perm);
        if (perm === "granted") {
          setActive(true);
          const sent = await sendTestPush().catch(() => 0);
          showSuccess("Notificaciones activas", sent ? "Te mandé una de prueba." : "Guardado. Las alertas llegarán aquí.");
        }
      }
    } catch (e) {
      logger.error(e);
      showError("No se pudo activar", e?.response?.data?.message || e?.message || "Intenta de nuevo.");
    } finally {
      setBusy(false);
    }
  };

  const Icon = active ? BellRing : state === "denied" || state === "unsupported" ? BellOff : Bell;
  const label = active ? "Notificaciones activas (toca para desactivar)" : "Activar notificaciones en este dispositivo";
  return (
    <button type="button" className={`sa-iconbtn ${active ? "is-on" : ""}`} onClick={onClick} disabled={busy} aria-label={label} title={label}>
      <Icon size={16} />
    </button>
  );
}
